'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var tslib_es6 = require('../../tslib.es6-130a177d.js');
var React = require('react');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

var Info = function (props) {
    var computedProps = tslib_es6.__assign({ fill: 'currentColor', width: 20, height: 20 }, props);
    return (React__default['default'].createElement("svg", tslib_es6.__assign({}, computedProps, { viewBox: "0 0 20 20", xmlns: "http://www.w3.org/2000/svg" }),
        React__default['default'].createElement("path", { fillRule: "evenodd", d: "M20 10C20 15.5228 15.5228 20 10 20C4.47715 20 0 15.5228 0 10C0 4.47715 4.47715 0 10 0C15.5228 0 20 4.47715 20 10ZM19 10C19 14.9706 14.9706 19 10 19C5.02944 19 1 14.9706 1 10C1 5.02944 5.02944 1 10 1C14.9706 1 19 5.02944 19 10ZM9.99083 7.01835C10.5596 7.01835 11 6.55963 11 6.02752C11 5.44037 10.5596 5 9.99083 5C9.44037 5 9 5.44037 9 6.02752C9 6.55963 9.44037 7.01835 9.99083 7.01835ZM9.24834 14.7103V8.85835C9.24834 8.70435 9.38834 8.55035 9.55634 8.55035H10.4375C10.5915 8.55035 10.7455 8.70435 10.7455 8.85835V14.7103C10.7455 14.8783 10.5915 15.0183 10.4375 15.0183H9.55634C9.38834 15.0183 9.24834 14.8783 9.24834 14.7103Z" })));
};

exports.default = Info;
//# sourceMappingURL=index.js.map
